<template>
    <paygate-button v-if="paygate" :paygateResponse="paygateResponse" />
</template>

<script>
    import PaygateButton from "./PaygateButton";
    export default {
        name: "PaygateRedirect",
        components: {
          PaygateButton
        },
        props: {
            recurring: {
                type: Boolean,
                default: false
            },
            debit: {
                type: Boolean,
                default: false
            },
        },
        data: () => ({
            loading: false,
            payfastButtonResponse: undefined,
            showForm: true,
            paygate: false,
            paygateResponse: undefined
        }),
    }
</script>

<style scoped>

</style>